import { alpha, Chip, ChipProps, styled } from '@mui/material'

interface IVitalSignSummaryProps extends Omit<ChipProps, 'size'> {
  value: string
  icon: React.ReactElement
  background: string
}

const StyledChip = styled(Chip)<IVitalSignSummaryProps>(
  ({ theme, background }) => ({
    color: background,
    background: theme.palette.background.default,
    border: '1px solid',
    borderColor: alpha(background, 0.5),
    fontSize: '0.8125rem',
    height: '32px',

    '& svg': {
      fill: background
    },

    '& .material-symbols-outlined': {
      color: background,
      fontSize: '18px'
    },

    '& .MuiChip-label': {
      fontSize: 'inherit',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  })
)

export const VitalSignSummary: React.FC<IVitalSignSummaryProps> = ({
  icon,
  value,
  background,
  title,
  ...props
}) => {
  return (
    <StyledChip
      {...props}
      icon={icon}
      background={background}
      label={value}
      value={value}
      title={title}
    />
  )
}

export default VitalSignSummary
